import React from 'react';

const CHAIN_ICONS = {
  // Ethereum: diamond shape logo
  Ethereum: (
    <>
      <polygon points="8,1 13,8 8,10.5 3,8" fill="#627EEA" />
      <polygon points="8,10.5 13,8 8,6" fill="#627EEA" opacity="0.6" />
      <polygon points="8,10.5 3,8 8,6" fill="#627EEA" opacity="0.8" />
      <polygon points="8,11.5 13,8.8 8,15 3,8.8" fill="#627EEA" />
    </>
  ),
  // Arbitrum: blue A with stylized orbit
  Arbitrum: (
    <>
      <circle cx="8" cy="8" r="7" fill="#2D374B" />
      <path d="M8 3.5L5 11h1.6l1.4-3.5L9.4 11H11L8 3.5z" fill="#28A0F0" />
      <path d="M7 8.5l1-2.5 1 2.5" stroke="#fff" strokeWidth="0.6" fill="none" />
    </>
  ),
  // Optimism: red O with inner circle
  Optimism: (
    <>
      <circle cx="8" cy="8" r="7" fill="#FF0420" />
      <text x="8" y="11.5" textAnchor="middle" fill="#fff" fontSize="10" fontWeight="700" fontFamily="Arial">O</text>
    </>
  ),
  // Base: blue circle with stylized B
  Base: (
    <>
      <circle cx="8" cy="8" r="7" fill="#0052FF" />
      <path d="M5.5 4v8h3c1.5 0 2.5-0.7 2.5-1.8 0-0.9-0.6-1.5-1.5-1.7 0.7-0.2 1.2-0.8 1.2-1.5C10.7 4.8 9.8 4 8.3 4H5.5zm1.3 1.1h1.3c0.8 0 1.3 0.4 1.3 1s-0.5 1-1.3 1H6.8V5.1zm0 3.1h1.5c0.9 0 1.4 0.4 1.4 1.1 0 0.7-0.5 1.1-1.4 1.1H6.8V8.2z" fill="#fff" />
    </>
  ),
  // Polygon: purple interconnected polygon shape
  Polygon: (
    <>
      <path d="M10.8 5.8L8.5 4.4c-0.3-0.2-0.7-0.2-1 0L5.2 5.8c-0.3 0.2-0.5 0.5-0.5 0.9v2.7c0 0.4 0.2 0.7 0.5 0.9l2.3 1.3c0.3 0.2 0.7 0.2 1 0l2.3-1.3c0.3-0.2 0.5-0.5 0.5-0.9V6.7c0-0.4-0.2-0.7-0.5-0.9z" fill="#8247E5" />
      <path d="M8 6.2L6.2 7.3v2l1.8 1 1.8-1v-2L8 6.2z" fill="#fff" opacity="0.4" />
    </>
  ),
  // BSC / BNB: yellow diamond pattern
  BSC: (
    <>
      <path d="M8 1.5l1.8 1.8-1.8 1.8-1.8-1.8z" fill="#F0B90B" />
      <path d="M12.5 6l1.8 1.8-1.8 1.8-1.8-1.8z" fill="#F0B90B" />
      <path d="M3.5 6l1.8 1.8-1.8 1.8-1.8-1.8z" fill="#F0B90B" />
      <path d="M8 10.5l1.8 1.8L8 14.2l-1.8-1.8z" fill="#F0B90B" />
      <path d="M8 6l2 2-2 2-2-2z" fill="#F0B90B" />
    </>
  ),
  // Solana: three parallelogram stripes with gradient
  Solana: (
    <>
      <defs>
        <linearGradient id="sol-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#9945FF" />
          <stop offset="100%" stopColor="#14F195" />
        </linearGradient>
      </defs>
      <path d="M2.5 11.2l1.2-1.2h10l-1.2 1.2H2.5z" fill="url(#sol-g)" />
      <path d="M2.5 4.8L3.7 6h10l-1.2-1.2H2.5z" fill="url(#sol-g)" />
      <path d="M2.5 8l1.2 1.2h10L12.5 8H2.5z" fill="url(#sol-g)" />
    </>
  ),
  // Avalanche: red triangle with white A cutout
  Avalanche: (
    <>
      <circle cx="8" cy="8" r="7" fill="#E84142" />
      <path d="M5.2 11h-1.8l4.6-8 1.2 2.1-2.8 5z" fill="#fff" />
      <path d="M9.2 11h3.4l-2.4-4.2L9 9h1.6L9.2 11z" fill="#fff" />
    </>
  ),
};

export default function ChainIcon({ chain, size = 16 }) {
  const icon = CHAIN_ICONS[chain];

  if (!icon) {
    return (
      <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: '50%',
        background: '#888',
        color: '#fff',
        fontSize: size * 0.55,
        fontFamily: "'IBM Plex Mono', monospace",
        fontWeight: 600,
        lineHeight: 1,
        flexShrink: 0,
      }}>
        {(chain || '?')[0].toUpperCase()}
      </span>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
    >
      {icon}
    </svg>
  );
}
